import React from "react";

function Footer() {
	return (
		<nav className="navbar navbar-light justify-content-center mb-1 bg-white shadow">
			<img src="../imgs/logo.png" style={{ width: 25, alignSelf: "center", marginRight: 10 }} className="card-img-top shadow rounded" />
			<small className="small text-secondary">
				Copyright &copy; {new Date().getFullYear()} - Desarrollado por el Team SysCom <br /> Todos los derechos reservados.
			</small>
		</nav>
	);
}

export default Footer;
